const getTableVariables = (
  {
    address,
    connectionTypes,
    slug,
    postcode,
    currentProvider,
    filters,
    params,
    filterConfig,
    order,
    uprn,
    udprn,
    device,
    comparisonId,
    addressProvided,
    sjidVariant,
    previewFlag,
    personalise,
    widelyAvailable,
    algorithmVersion
  },
  productsPerPage,
  showAds
) => ({
  address,
  connectionTypes,
  slug,
  device,
  comparisonId,
  postcode,
  limit: productsPerPage,
  sortBy: order,
  adsSortBy: order,
  personalise,
  showAds,
  widelyAvailable,
  algorithmVersion,
  filters: {
    ...filters,
    postcode,
    uprn,
    udprn,
    allDeals: !!params['all-deals'],
    currentProvider
  },
  adsFilters: {
    ...filters,
    postcode,
    allDeals: !!params['all-deals'],
    currentProvider
  },
  filterConfig: {
    speed: filterConfig.find((x) => x.objKey === 'speed').ranges,
    monthlyCost: filterConfig.find((x) => x.objKey === 'monthlyCost').ranges,
    broadbandTypeConfig: filterConfig.find((x) => x.objKey === 'broadbandTypes').broadbandTypeConfig
  },
  addressProvided,
  previewFlag,
  sjidVariant
})

export default getTableVariables
